import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Instagram, Menu, X, Phone, MessageCircle } from "lucide-react";
import { useState } from "react";

export default function SiteHeader() {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const nav = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/loans", label: "Loans" },
    { to: "/insurance", label: "Insurance" },
    { to: "/property", label: "Property" },
    { to: "/contact", label: "Contact" },
  ];
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-black/70 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <img src="/assets/sk-logo.jpeg" alt="SK Group" className="w-11 h-11 rounded-full ring-1 ring-[#D4AF37]/40" />
          <div className="hidden sm:block leading-tight">
            <div className="text-white font-display text-lg">SK Group</div>
            <div className="text-[10px] tracking-[0.28em] text-[#D4AF37] uppercase">Financial Services</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-sm font-medium transition-colors duration-200 hover:text-[#D4AF37] ${
                pathname === n.to ? "text-[#D4AF37]" : "text-white/80"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a data-testid="header-call" href="tel:+918866111559"
             className="p-2 rounded-full border border-white/10 text-white/80 hover:text-[#D4AF37] hover:border-[#D4AF37]/60 transition-colors" title="Call: +91 88661 11559">
            <Phone size={15}/>
          </a>
          <a data-testid="header-whatsapp" href="https://wa.me/918866111559" target="_blank" rel="noreferrer"
             className="p-2 rounded-full border border-emerald-500/40 text-emerald-400 hover:bg-emerald-500/10 transition-colors" title="WhatsApp: +91 88661 11559">
            <MessageCircle size={15}/>
          </a>
          <a data-testid="header-instagram" href="https://instagram.com/sk_group_finance_" target="_blank" rel="noreferrer"
             className="p-2 rounded-full border border-white/10 text-white/80 hover:text-[#D4AF37] hover:border-[#D4AF37]/60 transition-colors">
            <Instagram size={15}/>
          </a>
          {user && user.role ? (
            <>
              <Link
                data-testid="header-dashboard-link"
                to={user.role === "admin" ? "/admin" : "/dashboard"}
                className="text-sm text-white/85 hover:text-[#D4AF37] transition-colors"
              >
                {user.role === "admin" ? "Admin" : "Dashboard"}
              </Link>
              <button data-testid="header-logout" onClick={logout} className="sk-btn-ghost text-sm py-2 px-4">Logout</button>
            </>
          ) : (
            <>
              <Link data-testid="header-login" to="/login" className="text-sm text-white/85 hover:text-[#D4AF37]">Login</Link>
              <Link data-testid="header-apply-cta" to="/apply" className="sk-btn-gold text-sm py-2 px-5">Apply Now</Link>
            </>
          )}
        </div>

        <button data-testid="mobile-menu-btn" className="md:hidden text-white p-2" onClick={() => setOpen(!open)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-black/95">
          <div className="px-6 py-4 flex flex-col gap-3">
            {nav.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-white/85 py-1">
                {n.label}
              </Link>
            ))}
            {user && user.role ? (
              <>
                <Link to={user.role === "admin" ? "/admin" : "/dashboard"} onClick={() => setOpen(false)} className="text-[#D4AF37]">
                  {user.role === "admin" ? "Admin" : "Dashboard"}
                </Link>
                <button onClick={() => { logout(); setOpen(false); }} className="text-white/80 text-left">Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="text-white/85">Login</Link>
                <Link to="/apply" onClick={() => setOpen(false)} className="sk-btn-gold inline-block text-center">Apply Now</Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
